import {isTouchDevice} from "./picos/browserFns";
import Buffer from "safe-buffer";
import * as immer from "immer";
import {initializeArrayMapRegistry} from "./initializeArrayMapRegistry";
import {installChunkReloadHandler} from "./chunkReload";

// Recover from stale-deploy chunk load failures before anything can trigger them
installChunkReloadHandler();

Object.defineProperty(window, 'Buffer', {
    value: Buffer.Buffer,
    writable: true,
});

// Is this a mobile device?
window.__is_mobile__ = isTouchDevice()

// Initialize ArrayMap templates before Redux initializes (before any reducer imports)
initializeArrayMapRegistry();

immer.enableMapSet();
immer.enablePatches();